import { getAPIFromDomain } from "../../../lib/api";
import { useState } from "react";

const useUserDetails = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUserDetails = (userID) => {
    const url = `/users/${userID}`;
    const api = getAPIFromDomain();

    setError(null);
    setLoading(true);

    return api
      .get(url)
      .then((res) => {
        setData(res.data.user);
        setLoading(false);
        return res.data.user;
      })
      .catch((e) => {
        setError(e);
        setLoading(false);
      });
  };

  const updateUserDetails = (userID, body) => {
    const url = `/users/${userID}`;
    const api = getAPIFromDomain("accounts");

    setLoading(true);
    setError(null);

    return api
      .put(url, body)
      .then((res) => {
        setData(res.data);
        setLoading(false);
        return res.data;
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
        return false;
      });
  };

  const userDetails = { data, loading, error };

  return { userDetails, fetchUserDetails, updateUserDetails };
};

export { useUserDetails };
